module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CKE4dx/tc-custom/9781426857911.jpg?1706098609726",
      "alt": "This image is the cover for the book Bought by the Greek Tycoon, The Greek Tycoons"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bought by the Greek Tycoon, The Greek Tycoons\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A tycoon tries to buy more time with a widow following their steamy one-night stand in this contemporary romance by a "), _c('i', [_vm._v("USA Today")]), _vm._v(" bestseller.")]), _c('br'), _c('br'), _vm._v("Greek multimillionaire Luke Devetzi will do anything to get Jemma Barnes back in his bed for a night of blazing passion. . . . "), _c('br'), _c('br'), _vm._v("When Luke discovers that Jemma’s father is in financial trouble and in need of a loan, he is willing to pay it . . . but only if Jemma agrees to become his convenient wife!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jacqueline Baird\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("When Jacqueline Baird is not busy writing she likes to spend her time travelling, reading and playing cards. She enjoys swimming in the sea when the weather allows. With a more sedentary lifestyle, she does visit a gym three times a week and has made the surprising discovery that she gets some of her best ideas while doing mind-numbingly boring exercises on the weight machines and airwalker. Jacqueline lives with her husband Jim in Northumberland.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0